import {
    FETCH_MARKETDATA_BEGIN,
    FETCH_MARKETDATA_SUCCESS,
    FETCH_MARKETDATA_FAILURE,

    FETCH_MARKETDATADETAILS_BEGIN,
    FETCH_MARKETDATADETAILS_SUCCESS,
    FETCH_MARKETDATADETAILS_FAILURE,
} from '../constants/marketdata';

const initialState = {
    Indices: [],
    Marketdatadetails: {},
    isLoading: false,
    error: ""
}


export const getMarketData = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_MARKETDATA_BEGIN: {
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_MARKETDATA_FAILURE:
            return {
                ...state,
                isLoading: false,
                Indices: null
            };
        case FETCH_MARKETDATA_SUCCESS:
            return {
                ...state,
                Indices: payload.Indices,
                isLoading: true,
            };

        case FETCH_MARKETDATADETAILS_BEGIN: {
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_MARKETDATADETAILS_FAILURE:
            return {
                ...state,
                isLoading: false,
                Marketdatadetails: null
            };
        case FETCH_MARKETDATADETAILS_SUCCESS:
            return {
                ...state,
                Marketdatadetails: payload.Marketdatadetails,
                isLoading: true,
            };
      
        default:
            return state;
    }
}






